// @flow
import React, {useState, useContext, type Node} from 'react';

type ExpandContextType = {|
  setExpandedMap: ({[string]: boolean}) => void,
  expandedMap: {[string]: boolean},
|};

const ExpandContext = React.createContext<ExpandContextType>({
  setExpandedMap: () => undefined,
  expandedMap: {},
});

/* == context provider == */

type Props = {|
  children: Node,
|};

export const KBTreeExpandContextProvider = ({children}: Props) => {
  const [expandedMap, setExpandedMap] = useState<{[string]: boolean}>({});

  return (
    <ExpandContext.Provider value={{expandedMap, setExpandedMap}}>
      {children}
    </ExpandContext.Provider>
  );
};

/* == custom hook - allow categories know their expand state and change it == */

export const useExpandContext = (categoryURL: string) => {
  const {expandedMap, setExpandedMap} = useContext(ExpandContext);
  return {
    expanded: expandedMap[categoryURL],
    setExpanded: (value: boolean) =>
      setExpandedMap({
        ...expandedMap,
        [categoryURL]: value,
      }),
  };
};
